/* global sessionStorage */
/* global localStorage */

// mocking localStorage / sessionStorage for ios private
window.mockStorage = {
  session: {},
  local: {},
}

module.exports = class PortalStorage {

  // This will fail in Safari w/o Cookies, succeed everywhere else
  static get supported() {
    const k = 'TESTTEST'
    try {
      localStorage.getItem(k)
      localStorage.setItem(k, k)
      localStorage.removeItem(k)
      sessionStorage.setItem(k, k)
      sessionStorage.getItem(k)
      sessionStorage.removeItem(k)
      return true
    } catch (e) {
      return false
    }
  }

  static getTokenKey() {
    return "digiCATS-token"
  }

  static getUserDisplayNameKey() {
    return "digiCATS-displayName"
  }

  static getItem(localOrSession, key, defaultValue) {
    let ret
    if (! this.supported) {
      ret = window.mockStorage[localOrSession][key]
    } else {
      ret = this.supported ? (localOrSession === 'local' ? localStorage : sessionStorage).getItem(key) : defaultValue
    }
    if (!ret) ret = defaultValue
    return ret
  }

  static setItem(localOrSession, key, value) {
    if (! this.supported) {
      window.mockStorage[localOrSession][key] = typeof value === 'string' ? value : JSON.stringify(value)
    } else {
      const storage = localOrSession === 'local' ? localStorage : sessionStorage
      return storage.setItem(key, value)
    }
  }

  static getItemFromCookies(key) { return " " }
  
  static getTokenFromCookies() {
    return PortalStorage.getValueFromCookie(PortalStorage.getTokenKey());
  }

  static getUserDisplayNameFromCookies() {
    return PortalStorage.getValueFromCookie(PortalStorage.getUserDisplayNameKey());
  }

  static setUserCredentials(token, displayName) {

    // If the username is 'anonymous', set max-age to 1 day else 10 mins
    const max_age = (displayName === 'anonymous') ? 86400 : 600;

    PortalStorage.setTokenInCookies(token, max_age);
    PortalStorage.setUserNameInCookies(displayName, max_age);
  }


  static getValueFromCookie(keyName) {
    let val = null;
    let cookies_array = document.cookie.split(";")
    cookies_array.forEach(element => {
      let cookie_key_val = element.split("=");
      if (cookie_key_val[0].trim() === keyName) {
        val = cookie_key_val[1];
      } 
    });
    return val;
  }

  static setTokenInCookies(tokenVal, max_age) {
    PortalStorage.setItemInCookies(PortalStorage.getTokenKey(), tokenVal, max_age);
  }

  static setUserNameInCookies(username, max_age) {
  
    // Set the cookie with the chosen max-age
    PortalStorage.setItemInCookies(PortalStorage.getUserDisplayNameKey(), username, max_age);
  }
  
  
  static clearOutCookie() {
    // TODO: Improv. req to clear out all cookies values and not just token
    PortalStorage.setTokenInCookies("");
    PortalStorage.setUserNameInCookies("");
    // TODO Raghav: clear out username as well;
  }
  
  static setItemInCookies(key, value, max_age) { 
    var final_cookie_string = `${key}=${value};Path=/`;

    let max_age_string = `;max-age=${max_age}`;

    final_cookie_string+= max_age_string;

    document.cookie = final_cookie_string;
  }



}



//////////////////
// WEBPACK FOOTER
// ./js/PortalStorage.js
// module id = 4
// module chunks = 0